import Layout from '@/libs/components/Layout'
import { Popup, Toast } from 'antd-mobile'
import { useState, useEffect } from 'react'
import styles from './index.scss'
import { CloseOutline } from 'antd-mobile-icons'
import { goToEquityUrl, hex2Rgb } from '@/libs/functions/tools'
import moment from 'moment'
import goTo from '@/libs/functions/goTo'
import getChannelBridgeApi, {
  historyBackWFallback,
} from '@/libs/functions/appAdapter'
import { useModel, useSelector } from 'umi'
import { getStorage } from '@/libs/functions/onStorage'
import { RightOutline } from 'antd-mobile-icons'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.min.css'
import 'swiper/components/navigation/navigation.min.css'
import 'swiper/components/pagination/pagination.min.css'
import { isNumber } from 'lodash'
import NoticeLayout from '@/libs/components/noticeListLayout'

const unCurrentLevelText = '未达标'

type TemplateConfigType = {
  preTitle: string // 专区页面标题
  lvTitle: string // 等级权益标题
  btnText: string // 专区页面按钮文案
  exchangeRules: string //兑换规则
  listStyle: 1 | 2 // 权益列表样式 1:列表式 2:卡片式
  openGroup: boolean // 是否分组展示权益 true:开 false:关
  orderUrl: string // 历史订单地址
  showOrder: boolean // 是否展示历史订单
  showPersonal: boolean // 是否展示个人中心
}

// 等级专区
export default function Equity() {
  const [currentLevel, setCurrentLevel] = useState()
  const [slideIndex, setSlideIndex] = useState<number>()
  const [levelSwiper, setLevelSwiper] = useState<any>(null)
  const hideWebviewNavBar = getStorage('hideWebviewNavBar') == 1
  const [modalVisible, setModalVisible] = useState(false)
  const [modalInfo, setModalInfo] = useState<{
    title: string
    content: string
  }>({
    title: '',
    content: '',
  })
  const [sourceChannel, setSourceChannel] = useState('')
  let { baseInfo = {} } = useSelector((state: any) => state.LevelZone) || {}
  const {
    levelCode: defaultLevelCode,
    levelEquityListResps = [],
    showAllLevel,
    levelStatus,
  } = baseInfo

  useEffect(() => {
    if (levelStatus === 'invalid') {
      Toast.show('您不符合等级要求，无法访问！')
      goTo(-1)
      return
    }
  }, [levelStatus])

  useEffect(() => {
    setCurrentLevel(defaultLevelCode)
    const slideIndex = levelEquityListResps.findIndex(
      (item) => item.levelCode === defaultLevelCode,
    )
    setSlideIndex(slideIndex)
    // levelSwiper?.slideTo(slideIndex)
  }, [defaultLevelCode])

  const CurrentLevelRes =
    levelEquityListResps.find((item) => item.levelCode === currentLevel) || {}

  const {
    backGroundColor,
    backGroundImage,
    fontColor,
    backGroundType,
    themeColor,
    pageBackGroundColor,
    buttonBgColorStyle,
    buttonBgColor,
    buttonBgColor2,
    buttonTextColor,
    titleColor,
    moduleBackground,
    textColor,
    topBanner,
    levelName,
    memberMobile,
    levelExpirationEnd,
    equityCategoryRespList,
    levelEquityGroupRespList,
    productCategoryRespList,
    levelProductGroupRespList,
    totalCommonUerPoint,
    memberName,
    enableSection,
    sectionTitle,
    banners = [],
    activates = [],
    on,
  } = CurrentLevelRes || {}

  const styleConfig: any = {
    '--member-bg-color': pageBackGroundColor,
    '--member-primary-color': themeColor,
    '--member-primary-color-rgb': hex2Rgb(themeColor),
    '--member-card-bg-color':
      Number(backGroundType) === 1
        ? backGroundColor
        : `url(${backGroundImage}) no-repeat`,
    '--member-card-title-color': fontColor,
    '--member-btn-bg-color': buttonBgColor || themeColor,
    '--member-btn-bg-color2':
      buttonBgColorStyle === 'gradient'
        ? buttonBgColor2
        : buttonBgColor || themeColor,
    '--member-btn-text-color': buttonTextColor || '#fff',
    '--member-title-color': titleColor || '#fff',
    '--member-module-bg-color': moduleBackground || '#fff',
    '--member-text-color': textColor || '#fff',
    '--member-top-banner': `url(${topBanner}) no-repeat`,
  }

  console.log('styleConfig: ', styleConfig)

  const noticeStyle = {
    '--header-bg-color-rgb': hex2Rgb(themeColor),
    '--title-color': textColor,
    '--content-color': textColor || '#fff',
    '--content-bg-color': pageBackGroundColor || '#fff',
    '--btn-bg-color': buttonBgColor || themeColor,
    '--btn-bg-color2':
      buttonBgColorStyle === 'gradient'
        ? buttonBgColor2
        : buttonBgColor || themeColor,
    '--btn-color': buttonTextColor || '#fff',
  }

  const templateConfig: TemplateConfigType = CurrentLevelRes.templateConfig
    ? JSON.parse(CurrentLevelRes.templateConfig)
    : {}

  const { orderBtnText, needFilterOrder, personalText } = templateConfig

  const { qiankunGlobalState } = useModel('@@qiankunStateForSlave')
  const channel = qiankunGlobalState.channel

  const { hideNavBar, goBackWebview } = getChannelBridgeApi(channel)

  let equityList = templateConfig.openGroup
    ? levelEquityGroupRespList || []
    : [
        {
          groupName: '',
          equityCategoryRespList: equityCategoryRespList || [],
        },
      ]

  const isCurrentLevel = currentLevel === defaultLevelCode || !!on

  // console.log(isCurrentLevel)
  SwiperCore.use([Navigation, Pagination, Autoplay])
  useEffect(() => {
    const _sourceChannel =
      levelName && currentLevel ? `${levelName}(${currentLevel})` : ''
    sessionStorage.setItem('sourceChannel', _sourceChannel)
    setSourceChannel(_sourceChannel)
  }, [levelName, currentLevel])
  return (
    <div className={styles.layout} id="layout" style={styleConfig}>
      {levelStatus !== 'invalid' && !hideWebviewNavBar && (
        <div className={styles.navBar}>
          <img
            className={styles.backIcon}
            onClick={() => {
              historyBackWFallback(() => goTo(-1), goBackWebview)
            }}
            src={require('@/assets/image/memberEquity/back-ico.png')}
          />
          <p className={styles.title}>{templateConfig.preTitle}</p>
        </div>
      )}
      <NoticeLayout
        isReadyToShowNotice={!!defaultLevelCode}
        sectionCode={defaultLevelCode}
        marqueeStyle={{
          top: hideWebviewNavBar ? 0 : '13.333vw',
          ...noticeStyle,
        }}
        // style={{
        //   '--header-bg-color-rgb': hex2Rgb(themeColor),
        //   '--content-bg-color': pageBackGroundColor || '#222222',
        //   '--btn-bg-color': buttonBgColor || themeColor,
        //   '--btn-bg-color2':
        //     buttonBgColorStyle === 'gradient'
        //       ? buttonBgColor2
        //       : buttonBgColor || themeColor,
        //   '--btn-color': buttonTextColor || '#fff',
        // }}
        style={{
          ...noticeStyle,
        }}
      >
        {({ isShowRollNotice = false }) => (
          <>
            {levelStatus !== 'invalid' && (
              <>
                <div
                  className={styles.levelZone}
                  style={{
                    top: hideWebviewNavBar
                      ? isShowRollNotice
                        ? '10.167vw' // 40px
                        : 0
                      : isShowRollNotice
                      ? '23.5vw' // 97px
                      : '13.333vw', // 50px
                  }}
                >
                  <div className={styles['level-wrap']}>
                    {/* typeof slideIndex === 'number' && slideIndex > -1 &&  */}
                    {typeof slideIndex === 'number' && slideIndex > -1 && (
                      <Swiper
                        centeredSlides={true}
                        spaceBetween={0}
                        slidesPerView={1.12}
                        className={styles['level-swiper']}
                        initialSlide={slideIndex}
                        onSlideChange={(e) => {
                          setSlideIndex(e.activeIndex)
                          setCurrentLevel(
                            levelEquityListResps[e.activeIndex].levelCode,
                          )
                          // console.log(e.activeIndex)
                        }}
                        onSwiper={(swiper) => setLevelSwiper(swiper)}
                      >
                        {levelEquityListResps.map((level, index) => {
                          const isCurrentLevel =
                            level.levelCode === defaultLevelCode
                          const canUse = isCurrentLevel || level.on
                          return (
                            <SwiperSlide key={index}>
                              <section
                                className={styles.memberCard}
                                style={{
                                  background:
                                    Number(level.backGroundType) === 1
                                      ? level.backGroundColor
                                      : `url(${level.backGroundImage})  no-repeat`, // 图片或者颜色
                                  backgroundSize: 'cover',
                                }}
                              >
                                {isCurrentLevel && showAllLevel && (
                                  <div className={styles['current-label']}>
                                    当前
                                  </div>
                                )}
                                <div className={styles.levelName}>
                                  {level.levelName}
                                </div>
                                {canUse && (
                                  <div className={styles.entrance}>
                                    {templateConfig?.showPersonal && (
                                      <div
                                        className={styles.item}
                                        onClick={() => {
                                          goTo('/personal')
                                        }}
                                      >
                                        {personalText || '个人中心'}
                                        <RightOutline
                                          color="var(--member-card-title-color)"
                                          fontSize={12}
                                        />
                                      </div>
                                    )}
                                  </div>
                                )}
                                <p className={`${styles.text} ${styles.date}`}>
                                  {canUse
                                    ? `${moment(
                                        level.levelExpirationEnd,
                                      ).format('YYYY-MM-DD')}到期`
                                    : unCurrentLevelText}
                                </p>
                                {canUse && (
                                  <p
                                    className={`${styles.text} ${styles.phone}`}
                                  >
                                    {level.memberMobile}
                                  </p>
                                )}
                              </section>
                            </SwiperSlide>
                          )
                        })}
                      </Swiper>
                    )}
                  </div>

                  {!!isCurrentLevel && enableSection && (
                    <div className={styles['swiper-wrap']}>
                      <Swiper
                        autoplay
                        pagination
                        style={{ '--swiper-theme-color': '#ffffff' }}
                      >
                        {banners?.map((banner, index) => (
                          <SwiperSlide
                            key={index}
                            pagination={{ clickable: true }}
                          >
                            <div className={styles['swiper-banner']}>
                              <img
                                src={banner.activityImage}
                                onClick={
                                  banner.activityRedirectUrl
                                    ? () => goTo(banner.activityRedirectUrl)
                                    : undefined
                                }
                              />
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </div>
                  )}
                  <section className={styles.header}>
                    <h1>{templateConfig.lvTitle}</h1>
                    <p className={styles.right}>
                      {templateConfig.showExchangeRules &&
                        templateConfig.exchangeRules && (
                          <span
                            onClick={() => {
                              setModalInfo({
                                title: templateConfig.exchangeRulesText,
                                content: templateConfig.exchangeRules,
                              })
                              setModalVisible(true)
                            }}
                            className={styles.btn}
                          >
                            {templateConfig.exchangeRulesText}
                          </span>
                        )}
                      {templateConfig?.showOrder && (
                        <span
                          onClick={() => {
                            if (!needFilterOrder) {
                              goTo('/order/orderRecord?status=')
                            } else {
                              goTo(
                                `/order/orderRecord?sourceChannel=${sourceChannel}`,
                              )
                            }
                          }}
                          className={styles.btn}
                        >
                          {orderBtnText || '历史订单'}
                        </span>
                      )}
                    </p>
                  </section>

                  {!!equityList?.length ? (
                    <>
                      {/* 卡片式 */}
                      {templateConfig.listStyle === 1 &&
                        equityList.map((item: any, index: number) => (
                          <ul className={styles.equityList}>
                            {item.groupName && (
                              <h2 className={styles.titleWrap} key={index}>
                                <i className={styles.icon1}></i>
                                <i className={styles.icon2}></i>
                                <span className={styles.title}>
                                  {item.groupName}
                                </span>
                              </h2>
                            )}
                            {/* <li className={styles.mask}></li> */}
                            {item.equityCategoryRespList.map((equity: any) => (
                              <li className={styles.equityRowStyleItem}>
                                <img
                                  className={styles.icon}
                                  src={equity.listViewUrl}
                                  alt=""
                                />
                                <div className={styles.contentWrap}>
                                  <div className={styles.equityName}>
                                    {equity.equityName}
                                  </div>
                                  <div className={styles.equityContent}>
                                    {equity.relationDesc}
                                  </div>
                                </div>
                                <div className={styles.operationWrap}>
                                  <p className={styles.unit}>
                                    {equity.availableEquityNumName}
                                    {equity.unitName}
                                  </p>
                                  <span
                                    className={`${styles.btn} ${
                                      isCurrentLevel ? '' : styles.disable
                                    }`}
                                    onClick={() => {
                                      if (!isCurrentLevel) return
                                      // goTo(equity.equityCouponUrl)
                                      goToEquityUrl({
                                        equityCouponCode:
                                          equity.equityCouponCode,
                                        categoryType: equity.categoryType,
                                      })
                                    }}
                                  >
                                    {isCurrentLevel
                                      ? templateConfig.btnText
                                      : unCurrentLevelText}
                                  </span>
                                </div>
                              </li>
                            ))}
                          </ul>
                        ))}

                      {/* 列表式 */}
                      {templateConfig.listStyle === 2 &&
                        equityList.map((item: any, i: number) => (
                          <div
                            className={`${styles.equityList} ${styles.cardMode}`}
                            key={i}
                          >
                            {item.groupName && (
                              <h2 className={styles.titleWrap}>
                                <i className={styles.icon1}></i>
                                <i className={styles.icon2}></i>
                                <span className={styles.title}>
                                  {item.groupName}
                                </span>
                              </h2>
                            )}
                            <ul className={styles.equityCardWrap}>
                              {/* <li className={styles.mask}></li> */}
                              {item.equityCategoryRespList.map(
                                (equity: any) => (
                                  <li
                                    className={styles.equityCardStyleItem}
                                    key={equity.equityCode}
                                    // onClick={() => goTo(equity.equityCouponUrl)}
                                    onClick={() => {
                                      goToEquityUrl({
                                        equityCouponCode:
                                          equity.equityCouponCode,
                                        categoryType: equity.categoryType,
                                      })
                                    }}
                                  >
                                    <img
                                      className={styles.icon}
                                      src={equity.listViewUrl}
                                      alt=""
                                    />
                                    <div className={styles.inner}>
                                      <div className={styles.equityName}>
                                        {equity.equityName}
                                      </div>
                                      <p className={styles.unit}>
                                        {equity.availableEquityNumName}
                                        {equity.unitName}
                                      </p>
                                    </div>
                                  </li>
                                ),
                              )}
                            </ul>
                          </div>
                        ))}
                    </>
                  ) : (
                    <div className={styles.nodata}>
                      <img
                        className={styles.icon}
                        src={require('@/assets/image/memberEquity/empty-icon.png')}
                      />
                      <div className={styles.text}>暂无相关权益</div>
                    </div>
                  )}

                  {enableSection && isCurrentLevel && (
                    <div className={styles['activity-wrap']}>
                      {!!sectionTitle && (
                        <div className={styles['activity-title']}>
                          {sectionTitle}
                        </div>
                      )}
                      <div className={styles['activity-content']}>
                        {activates?.map((item) => (
                          <div
                            className={styles.flex}
                            onClick={
                              item.activityRedirectUrl
                                ? () => goTo(item.activityRedirectUrl)
                                : undefined
                            }
                          >
                            <img
                              className={styles.image}
                              src={item.activityImage}
                            />
                            <div className={styles.title}>
                              {item.activityName}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
                <Popup
                  className={styles.selectModal}
                  visible={modalVisible}
                  onMaskClick={() => {
                    setModalVisible(false)
                  }}
                  bodyStyle={{ background: 'transparent' }}
                >
                  <div className={`${styles.selectModal}`}>
                    <div className={styles.title}>
                      {modalInfo.title}
                      <CloseOutline
                        onClick={() => setModalVisible(false)}
                        className={styles.closeBtn}
                      />
                    </div>
                    <div
                      className={styles.content}
                      dangerouslySetInnerHTML={{
                        __html: modalInfo.content,
                      }}
                    ></div>
                  </div>
                </Popup>
              </>
            )}
          </>
        )}
      </NoticeLayout>
    </div>
  )
}
